import {apiClient} from "@/api/setupApi"

export default {
  getOrderAnalytics(): Promise<any> {
    return apiClient.get('v1/finance/client/analytics')
  },
}